<template>
    <!--TODO-->
    <!--<source-player></source-player>-->
    <div>
        <iframe :src="iframeSrc" frameborder="0" class="learnworlds-video-iframe  js-video-frame" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" playsinline webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>
        <!--<slot v-for="(_, name) in $slots" :name="name"></slot>-->
        <overlay @overlayClicked="logIt" >
            <slot name="overlay"></slot>
        </overlay>

        <icon>
            <slot name="icon"></slot>
        </icon>
    </div>
</template>

<script>
    import PageComponentMixin from '../mixins/PageComponentMixin'
    import Overlay from './Overlay.vue';
    import { glueParamsToUrl } from '../../commonjs/helpers.js';

    export default {
        name: 'Video',
        props: {
            provider: {
                type: String,
                required: true
            },
            videoParams: {
                type: Object,
            },
            videoId: {
                type: String,
            }
        },
        computed : {
            iframeSrc () {
                let videoUrl = "";

                if (this.provider === "vimeo") {

                    videoUrl = "https://player.vimeo.com/video/";
                    videoUrl += this.videoId;



                    let urlParams = {
                        controls: 0,
                        title: 0,
                        byline: 0,
                        portrait: 0
                    };

                    Object.keys(this.videoParams).map(videoParamKey => {
                        let videoParamValue = this.videoParams[videoParamKey];

                        if (videoParamKey && videoParamValue) {
                            urlParams[videoParamKey] = 1;
                        }
                    })

                    videoUrl = glueParamsToUrl(videoUrl,urlParams);


                } else if (this.provider === "wistia") {

                    let urlParams = {
//                        playbar : false,
//                        playButton : false,
//                        smallPlayButton : false,
//                        qualityControl : false,
//                        playbackRateControl : false,
//                        volumeControl : false,
//                        settingsControl : false,
//                        controlsVisibleOnLoad : false,
//                        videoFoam : false,
//                        fullscreenButton : false
                    };

                    videoUrl = "//fast.wistia.net/embed/iframe/";
                    videoUrl += eventData.videoId ;


                    Object.keys(eventData).map(videoParamKey => {
                        let videoParamValue = eventData[videoParamKey];

                        if (videoParamKey && videoParamValue && this.wistiaUrlKeys[videoParamKey]) {
                            urlParams[this.wistiaUrlKeys[videoParamKey]] = true;

                            if (videoParamKey === "loop") {
                                urlParams[this.wistiaUrlKeys[videoParamKey]] = "loop";
                            }

                            if (videoParamKey === "mute") {
                                urlParams["volumeControl"] = false;
                            }

                            let dataAttrParams = this.referenceNode.getAttribute("data-video-param") ? this.referenceNode.getAttribute("data-video-param") : "";
                            this.referenceNode.setAttribute("data-video-param" , dataAttrParams + " " + videoParamKey);
                        }

                    })

                    videoUrl = glueParamsToUrl(videoUrl,urlParams);

                }

                return videoUrl;
            }
        },
        methods : {
            logIt () {
            }
        },
        components : {
            Overlay
        }
    }
</script>